import React, { useContext, useEffect } from 'react';

import { Box, Typography, Grid, FormControlLabel } from '@mui/material';

import './TFactorScreen.scss';
import {} from '@mui/material';
import { AuthContext } from '../../../common/components/tfa-auth/contexts/authContext';

import IOSSwitch from './IOSSwitch';

const TFactorScreen: React.FC = () => {
  const authContext = useContext(AuthContext);
  const [mfaEnable, setMfaEnable] = React.useState(false);

  useEffect(() => {
    authContext.getMFAOption().then((res) => {
      setMfaEnable(res?.data?.mfa_active);
    });
  }, [authContext]);

  //use callback to respond to the switch
  const changeMfa = React.useCallback(
    (event) => {
      authContext.setMFAOption(event.target.checked).then((res) => {
        setMfaEnable(!mfaEnable);
      });
    },
    [mfaEnable, authContext]
  );

  return (
    <Grid
      container
      justifyContent='center'
      className='t-factor-screen-container'
    >
      <Box>
        <Typography
          fontWeight={600}
          color={'primary'}
          fontSize={24}
          className='t-factor-title'
        >
          Two-Factor authentication
        </Typography>
        <Grid className='t-factor-content'>
          <Typography>
            Allow to receive a verification code to your email
          </Typography>
          <FormControlLabel
            style={{ marginRight: '0' }}
            control={
              <IOSSwitch
                sx={{ m: 1 }}
                checked={mfaEnable}
                onChange={changeMfa}
              />
            }
            label=''
          />
        </Grid>
      </Box>
    </Grid>
  );
};

export default TFactorScreen;
